export default "__VITE_ASSET__6e64dc9c__"